
import * as dayjs from 'dayjs';

/** Version number of the application */
export const version = '0.4.0';
/** Version number of the base application */
export const core_version = '0.4.0';
/** Build time of the application */
export const build = dayjs(1589340098000);
